import React from "react";
import { Util } from "../../services/Utils/Util";


const ProfileImg: React.FC<{ url: string | undefined | null, className: string|undefined }> = ({ url, className }) => {
  return <img src={url ?? Util.ANONYMOUS_PHOTO_URL} alt="" className={`${className}`} ></img>
}

export default ProfileImg;